import * as React from 'react';

type Props = {
  isFiltersOpen: boolean;
  onToggleFilters: () => void;
  rightText?: React.ReactNode;
  actions?: React.ReactNode;
};

export const ClubProgrammeContentToolbarHeader: React.FC<Props> = ({
  isFiltersOpen,
  onToggleFilters,
  rightText,
  actions
}) => {
  return (
    <div className="cpToolbarRow cpToolbarRowDs">
      <button type="button" className={`cpDsIconTextBtn ${isFiltersOpen ? 'isActive' : ''}`} onClick={onToggleFilters}>
        Filters
      </button>

      <div className="cpMuted cpToolbarState">{isFiltersOpen ? 'Filters shown' : 'Filters hidden'}</div>

      <div className="cpToolbarActions">{actions}</div>

      <div className="cpMuted cpToolbarMeta">{rightText}</div>
    </div>
  );
};
